exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "vertical-slider {\n  display: block;\n  height: 100%; }\n  vertical-slider > .container {\n    height: 100%;\n    overflow: hidden; }\n    vertical-slider > .container .slider {\n      height: calc(100%);\n      transition: 1s ease-in-out transform;\n      position: relative; }\n      vertical-slider > .container .slider img {\n        display: block;\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n        margin-bottom: 2px; }\n", ""]);

// exports
